(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-ll-navigation]').forEach(header => {
      if (header.dataset.llNavigationReady) return;
      header.dataset.llNavigationReady = 'true';
      const closeDetails = detail => {
        detail.open = false;
        detail.querySelectorAll('details[open]').forEach(nested => { nested.open = false; });
      };
      header.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const detail = event.target.closest('details[open]');
        if (!detail || !header.contains(detail)) return;
        event.preventDefault();
        closeDetails(detail);
        detail.querySelector('summary').focus();
      });
      header.addEventListener('focusout', () => {
        setTimeout(() => {
          header.querySelectorAll('details[open]').forEach(detail => {
            if (!detail.contains(document.activeElement)) closeDetails(detail);
          });
        }, 0);
      });
      document.addEventListener('click', event => {
        if (!header.contains(event.target)) header.querySelectorAll('details[open]').forEach(closeDetails);
      });
      const desktop = matchMedia('(min-width: 1025px)');
      desktop.addEventListener('change', () => header.querySelectorAll('details[open]').forEach(closeDetails));
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
